<style type="text/css">
	.el-table_1_column_7 .cell, .el-table_1_column_10 .cell{
		text-align: center;
	}
	.el-select-dropdown__item span, .el-tag .el-select__tags-text{
		text-transform: capitalize;
	}
	.el-table_1_column_6 .cell{
		padding-left: 15px !important;
	}
	.el-table .warning-row, .el-table table.el-table__body tr.el-table__row.warning-row>td{
	    background: oldlace;
	}
</style>
<style scoped>
	.el-dialog__title{
	    position: absolute;
		top: 16px;
		left: 0;
		right: 0;
		z-index: 1;
	}
	.el-table th>.cell {
		word-break: break-word;
	}
	.content-wrapper .content{
		padding-top: 90px;
		padding-left: 5px;
		padding-right: 5px;
	}
	.heading-cart{
		position: relative;
		padding-left: 15px;
		padding-right: 15px;
	}
	.box-header .box-title {
		display: inline-block;
		font-size: 15px;
		padding: 10px;
		line-height: 1;
		color: black;
	}
	.heading-cart{
		margin-bottom: 0;
	}
	.box-body{
		padding: 0px 20px 20px;
	}
	.el-button.edit{
		padding: 5px 10px;
	}
	.select-input{
		width: 100%
	}
	.form-label{
		font-weight: bold;
		text-transform: capitalize;
	}
	button[disabled=disabled], button:disabled {
	    background-color: rgba(200,200,200,2.3);
	    border-color: rgba(200,200,200,2.3);
	    cursor: not-allowed;
	}
</style>
<template>
	<div class="content-wrapper">
		<section class="content">
			<div class="box">
				<div class="box-header with-border heading-cart">
					<h3 class="box-title">Publisher Reports Approval</h3>
					<div class='pull-right'>
						<el-button type="success" icon="el-icon-upload"  @click='confirmReUpload("updated",report_date)'>Re - Upload Report</el-button>

						<el-button v-if="getOverAllReportStatus(report_date)=='Approved'" type="success" class="approve-all-reports" @click="approveAllData(report_date,$event)" :icon="approveAllBtn">{{getOverAllReportStatus(report_date)}}</el-button>

						<el-button v-else type="primary" class="approve-all-reports" @click="approveAllData(report_date,$event)" :icon="approveAllBtn">{{getOverAllReportStatus(report_date)}}</el-button></div>
				</div>

				<div class="box-body p-b-15" style="max-height:80vh;overflow:auto;" v-loading="loading">
					<el-collapse accordion v-if="publisherDomainList.length!=0">
						<el-collapse-item v-for="data in publisherDomainList" :title="data.publisher" :name="data.publisher" class="collapse--item">
								<div v-for="(i,index) in data.domains" v-if="getFilteredReport(reportData,i).length>0">
					<el-collapse accordion>
						<el-collapse-item class="collapse--item">
											<template slot="title">
												<div style="width: 100%;">
													Report for {{i}}
												</div>
											</template>
											<el-table :data="getFilteredReport(reportData,i)" style="width: 100%;border-spacing: 0;" id="">
												<el-table-column label="Report Date" class='text-center'>
													<template slot-scope="props">
														{{getFormattedDate
														(props.row.date)}}

														<!-- {{getFilteredReport(reportData,i)}} -->
													</template>
												</el-table-column>
												<el-table-column label="Site" class='text-center' prop='site'></el-table-column>
												<el-table-column label="Dimension" class='text-center' prop='dimension'></el-table-column>		<el-table-column label="Bidder" class='text-center' prop='bidder'></el-table-column>
												<el-table-column label="Bidder Impression" class='text-center' prop='bidder_impression'></el-table-column>
												<el-table-column label="Bidder Revenue" class='text-center' prop='bidder_revenue'></el-table-column>
												<el-table-column label="DFP Impression" class='text-center' prop='dfp_impression'></el-table-column>
												<el-table-column label="DFP Revenue" class='text-center' prop='dfp_revenue'></el-table-column>
												<el-table-column label="Bidder eCPM" class='text-center'>
													<template slot-scope='props'>
														{{getExchangeRate(currencyArr,i)[0] +" "+getRoundedNumbers((props.row.bidder_revenue / props.row.bidder_impression)*1000)}}
													</template>
												</el-table-column>
												<el-table-column label="DFP eCPM" class='text-center'>
													<template slot-scope='props'>
														{{getExchangeRate(currencyArr,i)[0]+" "+getRoundedNumbers((props.row.dfp_revenue / props.row.dfp_impression)*1000)}}
													</template>
												</el-table-column>
											</el-table>
											<div class="container">
												<div class="row">
											<div class="col-md-4 col-sm-6 col-xs-12">
												<h5>DFP Total:</h5>
												<p>Total Revenue: {{getRevenueTotal(getFilteredReport(reportData,i),'dfp_revenue')}}</p>
												<p>Total Impressions: {{getValTotal(getFilteredReport(reportData,i),'dfp_impression')}}</p>
											</div>
											<div class="col-md-4 col-sm-6 col-xs-12">
												<h5>Bidder Total:</h5>
												<p>Total Revenue: {{getRevenueTotal(getFilteredReport(reportData,i),'bidder_revenue')}}</p>
												<p>Total Impressions: {{getValTotal(getFilteredReport(reportData,i),'bidder_impression')}}</p>

												<!-- {{getBidderRevenue(getFilteredReport(reportData,i),'rubicon')}} -->
											</div>
											<div class="col-md-4 col-sm-6 col-xs-12">
												<div>
													<h5>Exchange Rate for USD to {{getExchangeRate(currencyArr,i)[0]}}: </h5>
													<p>{{getExchangeRate(currencyArr,i)[0]+" "+getExchangeRate(currencyArr,i)[1]}}</p>
												</div>
												<div><el-button type="success" @click="approveData(i,report_date,$event)" :icon="approveBtn">{{getReportApprovalStatus(i)}}</el-button></div>
											</div>
											</div>
											</div>
											</el-collapse-item>
										</el-collapse>
								</div>

							</el-collapse-item>
						</el-collapse>
						<div v-else class="p-t-20 p-t-5">No data available</div>
					<el-dialog :visible.sync="UploadScreenVisible" class='report-upload-popup' :before-close='clearFilesList'>
						<!-- <span v-if="bidder_name=='updated'" class="el-dialog__title text-center">Upload {{bidder_name}} report</span> -->
						<span class="el-dialog__title text-center">Upload updated report for {{report_date}}</span>
						<el-upload v-loading=uploading
							class="upload-demo m-t-20"
							drag
							:limit=1
							action="reports/v1/upload/"
							:auto-upload="false"
							:http-request="upload"
							:on-preview="handlePreview"
							:on-remove="handleRemove"
							:file-list="fileList"
							ref='upload'>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">Drop file here or <em>click to upload</em></div>
							<div class="el-upload__text" slot="tip">Upload modified DFP + Bidder Report</div>
						</el-upload>
					<span slot="footer" class="dialog-footer">
						<el-button @click="cancelUploadAction">Cancel</el-button>
						<el-button type="success" @click="submitUpload">Upload Report</el-button>
					</span>
					</el-dialog>
				</div>
			</div>
		</section>
	</div>
</template>
<script type="text/javascript">
	import axios from 'axios';
	export default {
		data() {
			return{
				reportData:[],
				publishersList:[],
				publisherDomainList:[],
				pubData:{},
				UploadScreenVisible:false,
				report_date:'',
				bidder_name:'',
				frmdata:new FormData(),
				approvedData:undefined,
				approveBtn:'el-icon-check',
				currencyArr:[],
				site_list:new Set(),
				loading:true,
				approveAllBtn:'el-icon-check',
				reportApprovalStatus:[],
				reportOverallStatus:[],
				disabled:false,
				uploading:false
			}
		},
		created: function(){
			this.loading = true
			this.report_date=this.$route.params.reportName
			axios.all([
			axios.get(BASE_URL+'reports/v1/domain-list/'),
			axios.get(BASE_URL+`reports/v1/get-all-reports/${this.report_date}/`),
			axios.get(BASE_URL+`reports/v1/domain-currency-rate/${this.report_date}/`),
			axios.get(BASE_URL+`reports/v1/site-reports-approval-status/${this.report_date}/`),
			axios.get(BASE_URL+'reports/v1/reports-approval-status/')
			]).then(axios.spread((publisher,reports,currencyRate,reportStatus,reportOverallStatus)=>{
				// this.disabled=false
				this.reportOverallStatus=reportOverallStatus.data
				this.reportApprovalStatus=reportStatus.data
				this.currencyArr=currencyRate.data
				this.publishersList=publisher.data

				this.reportData=reports.data

				this.site_list = new Set(this.reportData.map((t)=>t.site))
				console.log(this.site_list)

				this.publisherDomainList = this.publishersList.filter(
					(x)=>{return x.domains.some(
						(k)=>{
							return [...this.site_list].indexOf(k)!=-1
							}
							)})
				this.loading=false
			})).catch(e=>{this.loading = false})
			// console.log('r',this.publisherDomainList)

		},
		methods: {
			upload:function(upload){
				// this.incrementNum++
				this.frmdata.append('reportFile',upload.file)
			},
			cancelUploadAction:function(){
				this.$refs.upload.clearFiles()
				this.UploadScreenVisible=false
			},
			clearFilesList:function(){
				this.$refs.upload.clearFiles()
				this.UploadScreenVisible = false
				// clearFiles on click. dialog inside table(unique dialog for each upload button) doesn't work. hence using these functions as workaround.
			},
			confirmReUpload(reportType,date) {
				this.$confirm('This will override previously uploaded file. Continue?', 'Warning', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancel',
				type: 'warning'
				}).then(() => {
					console.log('pass')
					this.UploadScreenVisible = true
				}).catch(() => {
				this.$message({
					type: 'info',
					message: 'Re-upload canceled'
				});
				});
      		},
			getOverAllReportStatus:function(date){
				let approvalStatus = this.reportOverallStatus.filter(k=>{return k.date==date})

				if(approvalStatus.length==2){
					return "Approve All"
				}else if(approvalStatus.length==1){
					// console.log("data",approvalStatus)
					if(approvalStatus[0].approve_status==true){
						return "Approved"
					}
					if(approvalStatus[0].approve_status==false){
						return "Approve All"
					}
				}else{
					return "Approve All"
				}
			},
			getReportApprovalStatus:function(site_name){
				// console.log("data",report_date)
				let approvalStatus = this.reportApprovalStatus.filter(k=>{return k.site_name==site_name})

				if(approvalStatus.length==2){
					return "Approve"
				}else if(approvalStatus.length==1){
					// console.log("data",approvalStatus)
					if(approvalStatus[0].approve_status==true){
						return "Approved"
					}
					if(approvalStatus[0].approve_status==false){
						return "Approve"
					}
				}else{
					return "Approve"
				}
			},
			getFilteredReport:function(allReportArr,domainToMatch){
				return allReportArr.filter((x)=>x['site']==domainToMatch)
				// this.loading=false
			},
			getFormattedDate:function(date){
				let report_date=new Date(date)
				let dd = report_date.getDate();
				let mm = report_date.getMonth() + 1; //January is 0
				let yyyy = report_date.getFullYear();

				if (dd < 10) {
				dd = '0' + dd;
				}

				if (mm < 10) {
				mm = '0' + mm;
				}

				report_date = yyyy + '-' + mm + '-' + dd;
				return report_date
			},
			getRoundedNumbers:function(val){
				let n = Number.parseFloat(val);
				if(!val || isNaN(n) || n < 0) return 0;
				return n.toFixed(2);
			},
			setReport:function(bidder_name,report_date){
				this.UploadScreenVisible = true
				this.report_date = report_date
				this.bidder_name = bidder_name
			},
			getRevenueTotal(arr,val){
				let sum_val=0
				for(var i in arr){
					let flt_val = parseFloat(this.getRoundedNumbers(arr[i][val]))
					sum_val+= flt_val
				}
				return Math.round(sum_val * 100) / 100
			},
			getValTotal(arr,val){
				let sum_val = 0
				for(var i in arr){
				  let int_val = parseInt(this.getRoundedNumbers(arr[i][val]))
				//   console.log(int_val)
				  sum_val+=int_val
				}
				return sum_val
			},
			approveData:function(domain,date){
				this.approveBtn = 'el-icon-loading'
				axios.post(BASE_URL+'reports/v1/approve-reports/',{report_date:date,domain:domain}).then((response)=>{
					console.log(response)
					this.approveBtn = 'el-icon-check'
				})
			},
			notificationMsg: function(type = 'Error', msg){
				this.$notify({
					title: type,
					message: (msg) ? msg : 'Oops Something went wrong!',
					type: type.toLowerCase()
				});
			},
			approveAllData:function(date){
				this.approveAllBtn = 'el-icon-loading'
				axios.post(BASE_URL+'reports/v1/approve-all-reports/',{report_date:date}).then((response)=>{
					// console.log(response.data.status)
					if(response.data.status == "success"){
					this.approveAllBtn = 'el-icon-check'
					jQuery('.approve-all-reports').removeClass("el-button--primary")
					jQuery('.approve-all-reports').addClass("el-button--success")
					this.notificationMsg(response.data.status,response.data.msg)
					}
					else{
						this.notificationMsg(response.data.msg)
					}
				})
			},
			submitUpload:function(){
				this.$refs.upload.submit();
				// this.uploadTrue='start';
				console.log(this.report_date)
				// if(this.bidder_name == 'updated'){
				// 	this.report_date = this.default_date
				// }else{
				this.report_date = this.report_date
				// }
				this.frmdata.append('report_date',this.report_date)
				this.frmdata.append('bidder','updated')
				this.frmdata.append('report_type','banner')
				this.uploading = true
				axios.post(BASE_URL+ 'reports/v1/upload/',this.frmdata).then(response => {
					this.uploading = false
					// console.log(response)
					this.notificationMsg((response.status) ? 'Success' : 'Error', response.data.data.message);
					if(response.data.status == 'Success'){
						this.UploadScreenVisible = false
						this.$refs.upload.clearFiles()
						setTimeout(() => {
							this.$router.push('/admin/reports');
							}, 500);
					}
					else{
						this.UploadScreenVisible = false
					}
				})
				.catch(e => {
					// console.log('test',e.response)
					this.uploading = false
					this.notificationMsg((e.response.data.data.status) ? 'Success' : 'Error', e.response.data.data.message);
					// this.UploadScreenVisible = false

				})

			},
			getExchangeRate:function(arr,i){
					let curArr = arr.filter((k)=>{return k['site']==i})

					let currency=''
					let exchange_rate=''
					if(curArr.length>0){
						currency = curArr[0].dfp_currency
						exchange_rate = curArr[0].exchange_rate_to_usd
					}
					else{
						return ''//data unavailable
					}

					if(currency!='Not available'){
					currency=currency}
					else{
					currency=''}
					return [currency,exchange_rate]
				// })
				// console.log(arr)
			},
			getBidderRevenue:function(arr,bidder){
				bidder_data = arr.filter((x)=>{
					return x['bidder']==bidder
				})
				console.log(this.getRevenueTotal(bidder_data,bidder))
			}
		}
	}
</script>


// WEBPACK FOOTER //
// BidderDfpReport.vue?c2763024